export const concatClasses = (...classes: string[]) => {
    return classes.join(' ');
};
